import React, { useEffect, useState } from 'react';
import { FiSave } from 'react-icons/fi';
import { useCurrentBoard } from '../../../services/state';
import { useBoardRecord } from '../../../services/deepstream';
import { updateBoardTitle } from '../../../services/board/board';
import Tooltip from '../../common/Tooltip';

import '../../../style/Title.css';

const Title = () => {
  const [titleInputValue, setTitleInputValue] = useState('');
  const { userRole } = useCurrentBoard();
  const { title } = useBoardRecord();
  const [status, setStatus] = useState('');
  const clearStatus = () => setStatus('');

  const canEditTitle = ['owner', 'editor'].includes(userRole);
  const tooltipTitle = canEditTitle ? 'Edit board title' : '';

  useEffect(() => {
    setTitleInputValue(title);
  }, [title]);

  const saveTitle = async () => {
    try {
      await updateBoardTitle(titleInputValue);

      setStatus('Saved!');
      setTimeout(clearStatus, 1500);
    } catch (error) {
      setStatus('Unable to save title');
    }
  };

  return (
    <div className="Title">
      <div className="default-title">
        <Tooltip title={tooltipTitle}>
          <input
            data-delay-show="500"
            data-delay-update="500"
            className="default-title Title-input"
            type="text"
            readOnly={!canEditTitle}
            value={titleInputValue}
            onChange={event => {
              setTitleInputValue(event.target.value);
            }}
            onKeyPress={event => {
              if (event.key === 'Enter') {
                saveTitle();
              }
            }}
          />
        </Tooltip>
        {canEditTitle && (
          <Tooltip title="Save title">
            <button
              data-delay-show="500"
              data-delay-update="500"
              className="save"
              onClick={saveTitle}
            >
              <FiSave size={'1rem'} />
            </button>
          </Tooltip>
        )}
      </div>
      <span className="title-status-text">{status}</span>
    </div>
  );
};

export default Title;
